import { render } from "./AnalysisPage.vue?vue&type=template&id=f0be4f8c&scoped=true"
import script from "./AnalysisPage.vue?vue&type=script&lang=js"
export * from "./AnalysisPage.vue?vue&type=script&lang=js"

import "./AnalysisPage.vue?vue&type=style&index=0&id=f0be4f8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0be4f8c"]])

export default __exports__